import { RxHR } from '@akanass/rx-http-request';

import { empty } from 'rxjs';
import { expand, reduce, map } from 'rxjs/operators';

import { PARAM_TYPE_PLACE, PARAM_TYPE_COMMENT, PARAM_TYPE_PHOTO, PARAM_TYPE_POI, PARAM_TYPE_WEATHER } from './constants';

// const basicUrl = "https://events.rolling2zwrotnik.pl:8443/apex/r2z/tt/";
const basicUrl = "https://apex.oracle.com/pls/apex/beyondhorizon/tt/";
const eventsEP = "v2/events";
const paramsRP = "event_parameters";
const zoomParam = "q_zoom_level";
const topLatParam = "q_ul_lat"
const leftLngParam = "q_ul_long";
const bottomLatParam = "q_lr_lat";
const rightLngParam = "q_lr_long";
const genTsParam = "q_gen_ts";
const source = "q_source";
const paramClass = 'q_p_class';
const eventParams = 'v3/parameters'
const distance = 'distance';

const getFetchAllLocationsUrl = () => basicUrl + eventsEP;
//const getFetchAllParamsUrl =  () => basicUrl + paramsRP;
const getFetchDistanceUrl = () => basicUrl + distance;
const getFetchLocationParamsUrl = locationId => basicUrl + paramsRP + locationId;
const getFetchAllPhotosUrl = () => basicUrl + paramsRP + "?";//q_param_type=" + PARAM_TYPE_PHOTO;
const getFetchAllImportantPlacesUrl = () => `${basicUrl}${paramsRP}?q_param_type=${PARAM_TYPE_PLACE}`;
const getPOIParametersUrl = () => `${basicUrl}${eventParams}?${paramClass}=${PARAM_TYPE_PHOTO}|${PARAM_TYPE_COMMENT}|${PARAM_TYPE_POI}|${PARAM_TYPE_WEATHER}`
//const getFetchWeatherForLocationUrl = () => basicUrl + paramsRP + "?type=weather";

export const fetchGpsJson = (dispatch) => {
    getData(`${window.location.origin}/gps.json`).subscribe(data => dispatch({ type: "FETCH_GPS_JSON", data }));
}

export const fetchAllLocations = (dispatch, fromDate) => {
    //ADD from date!
    let url = getFetchAllLocationsUrl() + "?";
    if (fromDate) {
        url = url + "q_gen_ts=" + fromDate;
    }
    pagingFetch(url).subscribe(data => dispatch({ type: "FETCH_LOCATIONS", data }));
}

export const fetchAllPosts = (dispatch) => {
    const url = getPOIParametersUrl();
    pagingFetch(url).subscribe(data => dispatch({ type: "FETCH_POSTS", data }));
}

export const fetchLocationsByBounds = (dispatch, genTs, zoom, bounds, user) => {
    //ADD from date!
    let url = getFetchAllLocationsUrl() + "?";
    if (genTs) {
        url = `${url}${genTsParam}=${genTs}&`;
    }
    if (zoom) {
        url = `${url}${zoomParam}=${zoom}&`;
    }
    if (bounds) {
        const topLat = bounds.getNorth();
        const leftLng = bounds.getWest();
        const bottomLat = bounds.getSouth();
        const rightLng = bounds.getEast();
        url = `${url}${topLatParam}=${topLat}&`;
        url = `${url}${bottomLatParam}=${bottomLat}&`;
        url = `${url}${leftLngParam}=${leftLng}&`;
        url = `${url}${rightLngParam}=${rightLng}&`;
        // url = `${url}${source}=Aleksandra`;
        // url = `${url}${source}=Tomasz`;
        // url = `${url}${source}=T01`;
        // url = `${url}${source}=Dareczek`;
    }
    if (user) {
        url = `${url}${source}=${user}`;
    }
    pagingFetch(url).subscribe(data => dispatch({ type: "FETCH_LOCATIONS", data }));
}

// export const fetchAppendLocations = (dispatch, genTs, user) => {
//     let url = getFetchAllLocationsUrl() + "?";
//     if (user) {
//         url = `${url}${source}=${user}`;
//     }
//     pagingFetch(url).subscribe(data => dispatch({ type: "APPEND_LOCATIONS", data }));
// }

export const fetchAllPhotos = (dispatch, fromDate) => {
    //ADD from date!
    let url = getFetchAllPhotosUrl();
    if (fromDate) {
        url = url + "&q_gen_ts=" + fromDate;
    }
    pagingFetch(url).subscribe(data => dispatch({ type: "FETCH_PHOTOS", data }))
}

export const fetchAllImportantPlaces = (dispatch, fromDate) => {
    //ADD from date!
    let url = getFetchAllImportantPlacesUrl();
    if (fromDate) {
        url = url + "&q_gen_ts=" + fromDate;
    }
    pagingFetch(url).subscribe(data => dispatch({ type: "FETCH_IMPORTANT_PLACES", data }))
}

export const fetchLocationParams = (dispatch, locationId) => {
    pagingFetch(getFetchLocationParamsUrl(locationId)).subscribe(data => dispatch({ type: "FETCH_IMPORTANT_PLACES", data }))
}

export const fetchAllDistance = (setDistance) => {
    getData(getFetchDistanceUrl()).subscribe( data => setDistance(data.items[0].distance));
}

const getData = url => RxHR.get(url, { json: true, headers: getHeaders() }).pipe(map(response => response.body));

const pagingFetch = (url) => {
    return getData(url).pipe(
        expand(body => body.next ? getData(body.next.$ref) : empty()),
        reduce((acc, data) => {
            acc.items = acc.items.concat(data['items']);
            return acc;
        },
            { items: [] })
    );
}

const getHeaders = () => {
    return { Authorization: 'Basic QkVZT05EVEhFSE9SSVpPTl9BUFA6OFBOYk5aaGQjI1FUYlg=' };
}